type messageType = "success" | "error" | "neutral" | "warning" | "info";

export class CustomMessageModel {
    type!: messageType
    message!: string
    title!: string
    loading?: boolean
    duration?: number
    dismissBtn?: boolean
    dismissBtnText?: string
    acceptBtn?: boolean
    acceptBtnText?: string
}
